import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import {
  DirectorConnectionService,
  DirectorConnectionState
} from './director-connection.service';

@Injectable()
/**
 * Guard that makes sure Director
 * is up and connected. Appropriate
 * for routes than require Director
 * support.
 */
export class DirectorConnectedGuard implements CanActivate, CanActivateChild {

  private _status: Observable<string>;

  constructor(
    private _store: Store<{ directorConnection: DirectorConnectionState }>,
    private _service: DirectorConnectionService
  ) {
    this._status = this._store.select(s => s.directorConnection.director)
      // Don't resolve until we get _something_ back from
      // the service so we can route immediately
      .filter(d => d !== undefined);;
  }

  canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
    return this._status.map(s => s == 'connected');
  }

  canActivateChild = (childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
    return this.canActivate(childRoute, state);
  }

}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/director-connection/director-connected.guard.ts